import { TextField } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import classnames from "classnames";
import { ACTION_STATES } from "core/actions";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import envconfig from "../../../envconfig";
import actions from "../logic/actions";
import "./styles.scss";
import {assertObject, assertString} from "core/validation";
import log from "loglevel";

const FilmSelect = ({ films, filmStatus, placeholder = "Search by title", defaultValue, onChange, onLoadFilms, ...props }) => {


    const [inputValue, setInputValue] = useState(defaultValue);
    const _onLoadFilms = _.debounce(onLoadFilms, envconfig.SEARCH_INPUT_DEBOUNCE_TIME);

    useEffect(() => {
        if (!inputValue) setInputValue(defaultValue);
    }, [defaultValue, inputValue]);

    const onInput = (e) => {
        setInputValue(e.target.value);
        if (e.target.value.length > envconfig.MAX_CHARACTERS_SEARCH_INPUT) {
            _onLoadFilms(e.target.value);
        }
    };

    const onKeyDown = (e) => {
        if (e.keyCode === 13 && assertString(inputValue)) {
            onChange(inputValue, false);
        }
    };

    const _onChange = (_, value) => {
        setInputValue(value ? value.label : "");
        log.debug("handle onchange filmselect", value)
        onChange(value, true);
    };

    const isLoading = filmStatus === ACTION_STATES.SEND;
    const data = films.map((cTitle) => ({ value: cTitle.id, label: cTitle.title }));


    const getOptionLabel = (option) => {
        if(!assertObject(option)) {
            return "";
        } else {
            return  option?.label ? option.label : option;
        }
    }

    function handleInputChange(e, value) {
        if(!assertString(value)) {
            setInputValue("");
            onChange(null, false);
        }
    }
    return (
        <Autocomplete
            className={classnames("film-autocomplete", props.className)}
            freeSolo
            options={data}
            onChange={_onChange}
            loading={isLoading}
            getOptionLabel={getOptionLabel}
            autoHighlight
            onInputChange={handleInputChange}
            autoComplete={false}
            slotProps={{
                clearIndicator:{
                    color:"inherit",
                }
            }}
            onKeyDown={(event) => {
                if (event.key === 'Enter') {
                    // Prevent's default 'Enter' behavior.
                    event.defaultMuiPrevented = true;
                }
            }}
            getOptionKey={(option) => option?.value}
            renderInput={(params) => {
                return (
                    <TextField
                        className="form-control"
                        {...params}
                        placeholder={placeholder}
                        margin="normal"
                        variant="outlined"
                        inputValue={inputValue || ""}
                        onChange={onInput}
                        onKeyDown={onKeyDown}
                    />
                );
            }}
        />
    );
};

export default connect(
    ({ globalApp }) => ({
        films: globalApp.films,
        filmsStatus: globalApp.filmStatus,
    }),
    (dispatch) => ({
        onLoadFilms: (str) => dispatch(actions.APP_SEARCH_FILMS.send(str)),
    })
)(FilmSelect);
